import { ISegmentDefinition } from '../../types';

export const BingAndYahooSearch: ISegmentDefinition = {
  segment: 'BingAndYahooSearch',
  titleKey: 'Segment_Network_BingAndYahoo',
};

export const AOLSearch: ISegmentDefinition = {
  segment: 'AOLSearch',
  titleKey: 'Segment_Network_AOL',
};
